export default [
    {
        path: '',
        component: () => import('../views/marketing/Index.vue'),
        meta: { requiresAuth: true, title: 'Маркетинг', activeSideIcon: '#icon-chart' },
        children: [
        {
            path: '/(uk/|ru/)?marketing',
            name: 'MarketingOverview',
            component: () => import('../views/marketing/tabs/OverviewTab.vue'),
            meta: { requiresAuth: true, title: 'Маркетинг · Обзор', activeSideIcon: '#icon-chart' },
        },
        {
            path: '/(uk/|ru/)?marketing/channels',
            name: 'MarketingChannels',
            component: () => import('../views/marketing/tabs/ChannelsTab.vue'),
            meta: { requiresAuth: true, title: 'Маркетинг · Номера', activeSideIcon: '#icon-chart' },
        },
        {
            path: '/(uk/|ru/)?marketing/rules',
            name: 'MarketingRules',
            component: () => import('../views/marketing/tabs/RulesTab.vue'),
            meta: { requiresAuth: true, title: 'Маркетинг · Правила', activeSideIcon: '#icon-chart' },
        },
        {
            path: '/(uk/|ru/)?marketing/events',
            name: 'MarketingEvents',
            component: () => import('../views/marketing/tabs/EventsTab.vue'),
            meta: { requiresAuth: true, title: 'Маркетинг · События', activeSideIcon: '#icon-chart' },
        },
        {
            path: '/(uk/|ru/)?marketing/settings',
            name: 'MarketingSettings',
            component: () => import('../views/marketing/tabs/SettingsTab.vue'),
            meta: { requiresAuth: true, title: 'Маркетинг · Подключение', activeSideIcon: '#icon-chart' },
        },
        {
            path: '/(uk/|ru/)?marketing/audit',
            name: 'MarketingAudit',
            component: () => import('../views/marketing/tabs/AuditTab.vue'),
            meta: { requiresAuth: true, title: 'Маркетинг · История изменений', activeSideIcon: '#icon-chart' },
        },
        ],
    },
    {
        path: '/(uk/|ru/)?/self-emloyment/status-history',
        name: 'selfemploymentIndex',
        component: () => import('../views/selfemployment/index'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'История статусов'
        },
    }, {
        path: '/(uk/|ru/)?/self-emloyment/without-employment',
        name: 'selfemploymentDrivers',
        component: () => import('../views/selfemployment/drivers'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Без самозанятости'
        },
    }, {
        path: '/(uk/|ru/)?/self-emloyment/option',
        name: 'selfemploymentReference',
        component: () => import('../views/selfemployment/reference'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Самозанятость Настройки'
        },
    }, {
        path: '/(uk/|ru/)?/car/index',
        name: 'ListAuto',
        component: () => import('../views/rentauto/ListAuto.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Список авто'
        },
    }, {
        path: '/(uk/|ru/)?/car/all-car',
        name: 'ListAllCar',
        component: () => import('../views/rentauto/ListAllCar.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-angle-right',
            title: 'Список всех авто'
        },
    }, {
        path: '/(uk/|ru/)?/car/create',
        name: 'createAuto',
        component: () => import('../views/rentauto/modules/create.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-rent-car',
            title: 'Список авто',
            altNavSubMenuActive:'/car/index',
        },
    }, {
        path: '/(uk/|ru/)?/car/view',
        name: 'viewAuto',
        component: () => import('../views/rentauto/modules/view.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-rent-car',
            title: 'Просмотр авто',
            altNavSubMenuActive:'/car/all-car',
        },
    }, {
        path: '/(uk/|ru/)?/request/index',
        name: 'ListRent',
        component: () => import('../views/rentauto/ListRent.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-rent-car',
            title: 'Аренда Авто',
        },
    }, {
        path: '',
        name: 'task-pool',
        component: () => import('../views/financial/TaskPool.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-financial',
            altNavSubMenuActive:'/financial/task-pool',
        },
        children: [{
            path: '/(uk/|ru/)?/financial/task-pool',
            name: 'Task',
            component: () => import('../views/financial/Task'),
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-financial',
                title: 'Финансовый мониторинг'
            },
        }, {
            path: '/(uk/|ru/)?/financial/history',
            name: 'TaskHistory',
            component: () => import('../views/financial/History'),
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-financial',
                title: 'Финансовый мониторинг',
            },
        },]
    }, {
        path: '',
        name: 'ie_main',
        component: () => import('../views/individual-entrepreneurship/list.vue'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-ie',
            title: 'Список ИП',
        },
        children: [{
            path: '/(uk/|ru/)?/individual-entrepreneurship/list',
            name: 'ie_List',
            component: () => import('../views/individual-entrepreneurship/tables/list.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }, {
            path: '/(uk/|ru/)?/individual-entrepreneurship/app',
            name: 'ie_app',
            component: () => import('../views/individual-entrepreneurship/tables/app.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }]
    }, {
        path: '/(uk/|ru/)?/individual-entrepreneurship/create',
        name: 'ie_create',
        component: () => import('../views/individual-entrepreneurship/create.vue'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-ie',
            title: 'Создание нового ИП',
        },
    }, {
        path: '',
        name: 'ie_edit_form',
        component: () => import('../views/individual-entrepreneurship/Edit.vue'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-ie',
            title: 'Создание нового ИП',
        },
        children: [{
            path: '/(uk/|ru/)?/individual-entrepreneurship/edit',
            name: 'ie_edit',
            component: () => import('../views/individual-entrepreneurship/tab_edit.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }, {
            path: '/(uk/|ru/)?/individual-entrepreneurship/edit/driver',
            name: 'ie_subDriver',
            component: () => import('../views/individual-entrepreneurship/driver.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }]
    }, {
        path: '',
        name: 'nca',
        component: () => import('../views/NCALayer/index.vue'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            title: 'NACLayer',
        },
        children: [{
            path: '/(uk/|ru/)?/ie/docs',
            name: 'ie_docs',
            component: () => import('../views/NCALayer/tables/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
            },
        }, {
            path: '/(uk/|ru/)?/ie/docs/invoice',
            name: 'ie_docs-invoice_month',
            component: () => import('../views/NCALayer/tables/docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Карточка ИП',
                type: 'invoice_month'
            },
        }, {
            path: '/(uk/|ru/)?/ie/docs/ya',
            name: 'ie_docs-ya_docs',
            component: () => import('../views/NCALayer/tables/ya_docs.vue'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-ie',
                title: 'Документы от Яндекс',
            },
        }]
    }, {
        path: '/(uk/|ru/)?/candidates/AI',
        name: 'reportsCandidatesAiNew',
        component: () => import('../views/drivers/default/CandidatesAI'),
        meta: {
            requiresAuth: true,
            title: 'Кандидаты от ИИ: Новые',
        },
    }, {
        path: '/(uk/|ru/)?/candidates/AI/finished',
        name: 'reportsCandidatesAiNewFinished',
        component: () => import('../views/drivers/default/CandidatesAIFinished'),
        meta: {
            requiresAuth: true,
            title: 'Кандидаты от ИИ: Завершенные',
        },
    }, {
        path: '/(uk/|ru/)?/drivers/AI',
        name: 'mutualSettlementDetail',
        component: () => import('../views/drivers/default/DriversAI'),
        meta: {
            requiresAuth: true,
            title: 'Водители от ИИ',
        },
    }, {
        path: '/(uk/|ru/)?/chats/AI',
        name: 'mutualSettlementDetail',
        component: () => import('../views/drivers/default/ChatsAI'),
        meta: {
            requiresAuth: true,
            title: 'Водители от ИИ',
        },
    }, {
        path: '/(uk/|ru/)?/overdraft/index',
        name: 'mutualSettlementDetail',
        component: () => import('../views/overdraft/index'),
        meta: {
            activeSideIcon:'#icon-coins',
            requiresAuth: true,
            title: 'Овердрафт',
        },
    },
]
